import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

i18n
  .use(HttpApi) // Charge les fichiers de traduction
  .use(LanguageDetector) // Détecte automatiquement la langue du navigateur
  .use(initReactI18next) // Intègre i18next avec React
  .init({
    supportedLngs: ['en', 'fr', 'he'], // Liste des langues prises en charge
    fallbackLng: 'en', // Langue par défaut si la traduction est manquante
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag', 'path', 'subdomain'],
      caches: ['cookie', 'localStorage'], // Où stocker la langue détectée
    },
    backend: {
      loadPath: '/locales/{{lng}}/translation.json', // Chemin pour les fichiers de traduction
    },
    react: { useSuspense: false }, // Désactiver le suspense si nécessaire
  });

export default i18n;
